import React from 'react';

import { PartHistory } from '../../../../components/molecules/PartHistory';
import { useGetPartHistoryByPartId } from '../../../../queries/part-query';

import { PartHistoryFragmentProps } from '.';

export const PartHistoryFragment: React.FC<PartHistoryFragmentProps> = ({ partId }) => {
  const getPartHistoryByPartId = useGetPartHistoryByPartId(partId);
  const partHistory = getPartHistoryByPartId.data ?? [];

  return (
    <PartHistory
      partHistoryData={partHistory}
      partId={partId}
      isLoading={getPartHistoryByPartId.isLoading}
    />
  );
};
